import { SendEventProps } from '../../interfaces/biEvents';

export const mpBrandTooltipDisplayed = () =>
    ({
        eventName: 'Notable clients - brand tooltip displayed',
    } satisfies SendEventProps);
